const categorySelection = document.getElementById("categorySelection");
const dailyWinnersView = document.getElementById("dailyWinnersView");
const principalWinnersView = document.getElementById("principalWinnersView");
const winnersContainer = document.getElementById("winnersContainer");
const searchDailyWinners = document.getElementById(
  "searchDailyWinners",
) as HTMLInputElement | null;

function showNonHomeView() {
  winnersContainer?.classList.add("bg-cream");
  winnersContainer?.classList.remove(
    "bg-[url(/images/ganadores_contenedor_1.svg)]",
  );
}

function showHomeView() {
  winnersContainer?.classList.remove("bg-cream");
  winnersContainer?.classList.add(
    "bg-[url(/images/ganadores_contenedor_1.svg)]",
  );
}

document.getElementById("btnDaily")?.addEventListener("click", () => {
  categorySelection?.classList.add("hidden");
  dailyWinnersView?.classList.remove("hidden");
  showNonHomeView();
});

document.getElementById("btnPrincipal")?.addEventListener("click", () => {
  categorySelection?.classList.add("hidden");
  principalWinnersView?.classList.remove("hidden");
  showNonHomeView();
});

document.getElementById("btnBackDaily")?.addEventListener("click", () => {
  dailyWinnersView?.classList.add("hidden");
  categorySelection?.classList.remove("hidden");
  showHomeView();
  searchDailyWinners?.blur();
  searchDailyWinners!.value = "";
  searchDailyWinners!.dispatchEvent(new Event("input"));
});

document.getElementById("btnBackPrincipal")?.addEventListener("click", () => {
  principalWinnersView?.classList.add("hidden");
  categorySelection?.classList.remove("hidden");
  showHomeView();
});

searchDailyWinners?.addEventListener("input", (e: Event) => {
  const target = e.target as HTMLInputElement;
  const query = target.value.toLowerCase().trim();

  document.querySelectorAll("#dailyWinnersList .winner-row").forEach((row) => {
    const name = row.getAttribute("data-name") || "";
    (row as HTMLElement).style.display =
      query === "" || name.includes(query) ? "flex" : "none";
  });
});
